module.exports = __webpack_public_path__ + "img/c05cd98.jpg";